module.exports = __webpack_public_path__ + "fonts/IQOS-Regular.2e930ed.woff";